import { ArrowLeftIcon, UserCircleIcon } from '@heroicons/react/20/solid';
import { useClickAway } from '@uidotdev/usehooks';
import { useAuth } from 'oidc-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export default function Header(props) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="p-6 flex justify-between max-w-3xl md:m-auto">
        {props.backTo && <ArrowLeftIcon className="h-6 w-6" onClick={() => navigate(props.backTo)} />}
        <div className="ml-auto flex gap-3 text-gray-800">
          {/* <EnvelopeIcon className="h-6 w-6" /> */}
          <UserActions token={props.token} env={props.env} />
        </div>
      </div>
      <div className="h-[1px] bg-gradient-to-r from-primary-500 to-pink-600" />
    </div>
  );
}

export const UserActions = ({ env, token }) => {
  const [userOpen, setUserOpen] = useState(false);
  const auth = useAuth();
  const dropdownRef = useClickAway<HTMLDivElement>(() => setUserOpen(false));
  const handleLogout = () =>
    auth.signOutRedirect({
      post_logout_redirect_uri: `${window.location.origin}`,
    });

  return (
    <div className="relative">
      <UserCircleIcon
        onClick={() => {
          setUserOpen(!userOpen);
        }}
        className="h-6 w-6"
      />

      <div
        ref={dropdownRef}
        className={`${
          userOpen ? 'block' : 'hidden'
        } absolute text-right right-0 mt-2 min-w-56 p-4 flex flex-col gap-3 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
      >
        {auth.userData && (
          <div className="text-sm whitespace-nowrap text-gray-500">User: {auth.userData?.profile.email}</div>
        )}
        {/* <div onClick={() => setCallForProfile()}>Settings</div> */}

        <div onClick={handleLogout}>Logout</div>
      </div>
    </div>
  );
};
